import * as f from './Funcs';

/**
 * Утилита для логирования на фронтенде
 * Отправляет логи на сервер для записи в единый лог-файл
 */
class Logger {
    /**
     * Отправляет лог на сервер
     * @param {string} level - Уровень лога ('INFO', 'WARN', 'ERROR', 'DEBUG')
     * @param {string} message - Сообщение для логирования
     */
    static async sendLog(level, message) {
        try {
            // Формируем полное сообщение с контекстом
            const fullMessage = typeof message === 'string' ? message : JSON.stringify(message);
            
            // Определяем путь к API
            const homePath = window.IasConfig?.homePath || '';
            const logUrl = `${homePath}logger/log`;
            
            // Для отладки - выводим в консоль тоже
            if (window.IasConfig?.devMode) {
                console.log(`[Logger] Sending ${level}: ${fullMessage.substring(0, 100)}`);
            }
            
            // Отправляем на сервер асинхронно (не блокируем выполнение)
            fetch(logUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    level: level,
                    message: fullMessage
                }),
                credentials: 'include'
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (window.IasConfig?.devMode && !data.success) {
                    console.warn(`[Logger] Server returned error: ${data.error}`);
                }
            })
            .catch(error => {
                // Если не удалось отправить на сервер, выводим в консоль
                console.error(`[Logger] Failed to send log to server (${logUrl}):`, error);
                console.log(`[${level}] ${fullMessage}`);
            });
        } catch (error) {
            // Fallback на console.log если что-то пошло не так
            console.error('[Logger] Error:', error);
            console.log(`[${level}] ${message}`);
        }
    }

    /**
     * Логирует информационное сообщение
     * @param {string|object} message - Сообщение или объект для логирования
     */
    static info(message) {
        this.sendLog('INFO', message);
    }

    /**
     * Логирует предупреждение
     * @param {string|object} message - Сообщение или объект для логирования
     */
    static warn(message) {
        this.sendLog('WARN', message);
    }

    /**
     * Логирует ошибку
     * @param {string|object} message - Сообщение или объект для логирования
     */
    static error(message) {
        this.sendLog('ERROR', message);
    }

    /**
     * Логирует отладочное сообщение
     * @param {string|object} message - Сообщение или объект для логирования
     */
    static debug(message) {
        this.sendLog('DEBUG', message);
    }

    /**
     * Логирует сообщение с разделителями (для группировки связанных логов)
     * @param {string} action - Действие (например, 'START', 'END')
     * @param {string} context - Контекст (например, название функции)
     * @param {string|object} message - Дополнительное сообщение
     */
    static section(action, context, message = '') {
        const separator = '='.repeat(50);
        const msg = message ? ` ${message}` : '';
        this.info(`${separator}`);
        this.info(`${action} ${context}${msg}`);
        this.info(`${separator}`);
    }
}

// Тестовая запись при загрузке модуля (только в dev режиме)
if (typeof window !== 'undefined' && window.IasConfig?.devMode) {
    // Небольшая задержка, чтобы убедиться, что все загружено
    setTimeout(() => {
        Logger.info('Logger module loaded on client');
    }, 1000);
}

export default Logger;

